import { RootState } from '../store';
import {UploadStatus} from "../slices";

export const selectUploadProgress = (state: RootState) => state.upload.progress;

export const selectFileStatuses = (state: RootState) => state.upload.fileStatuses;

export const selectFailedFiles = (state: RootState) => {
  return state.upload.fileStatuses.filter(
    (status) => status.status === UploadStatus.ERROR
  );
};

export const selectSuccessfulFiles = (state: RootState) => {
  return state.upload.fileStatuses.filter(
    (status) => status.status === UploadStatus.COMPLETED
  );
};

export const selectStoppedFiles = (state: RootState) => {
  return state.upload.fileStatuses.filter(
    (status) => status.status === UploadStatus.CANCELLED
  );
};